import {
  BACKUP_RETENTION_DAY_OPTIONS,
  type BackupFrequency,
  type BackupRetention,
  type BackupsManagementFormValues,
  ManagementTab,
} from './types';

export enum BACKUP_TYPES {
  FILE = 'File',
  DATABASE = 'Database',
  FULL_SITE = 'Full Site',
  HOME = 'home',
  DB = 'db',
  HOME_DB = 'home_db',
  WEBSITE = 'Website',
  OCI = 'oci',
}

export enum FILE_BACKUP_TYPES {
  FILE_RESTORE = 'File Restore',
  FILE_DOWNLOAD = 'File Download',
}

export enum DATABASE_BACKUP_TYPES {
  DATABASE_RESTORE = 'Database Restore',
  DATABASE_DOWNLOAD = 'Database Download',
}

export enum BACKUP_STATUS_TYPES {
  IN_PROGRESS = 'In_Progress',
  COMPLETED = 'Completed',
  ERROR = 'Error',
  Failed = 'Failed',
  Pending = 'Pending',
  BACKUP_RESTORE_COMPLETE = 'restore_completed',
  BACKUP_RESTORE_STARTED = 'restore_started',
}

export enum BACKUP_EVENT_TYPES {
  BACKUP_COMPLETE = 'completed',
  BACKUP_FAILED = 'failed',
  BACKUP_STARTED = 'started',
  BACKUP_SUPPORT = 'support',
}

export const EVT_IDX_TYPE = 3; // e.g., 'db' | 'home'
export const EVT_IDX_ACTION = 2; // e.g., contains 'download' or 'restore',
export const EVT_IDX_STATUS = 4; // e.g., contains 'failed'
export const EVT_IDX_DETAIL = 6; // backend-specific (snapshot timestamp or site id)
export const EVT_IDX_PLAN = 5; // e.g., 'free', 'premium'

/** Backups Management modal - frequency select options */
export const BACKUPS_MANAGEMENT_FREQUENCIES: BackupFrequency[] = [
  'daily',
  'weekly',
  'monthly',
];

/** Backups Management modal - retention select options */
export const BACKUPS_MANAGEMENT_RETENTION_OPTIONS: BackupRetention[] = [
  'unlimited',
  ...BACKUP_RETENTION_DAY_OPTIONS,
];

/** Segmented tabs for Backups Management modal */
export const BACKUPS_MANAGEMENT_TAB_OPTIONS: ReadonlyArray<{
  value: ManagementTab;
  labelKey: string;
  testId: string;
}> = [
  {
    value: ManagementTab.Schedule,
    labelKey: 'schedule.tab',
    testId: 'backups-management-tab-schedule',
  },
  {
    value: ManagementTab.Email,
    labelKey: 'emailNotifications.tab',
    testId: 'backups-management-tab-email',
  },
];

export const DEFAULT_BACKUPS_MANAGEMENT_FORM_VALUES: BackupsManagementFormValues =
  {
    autoBackupEnabled: true,
    scheduleTime: null,
    frequency: 'daily',
    retention: 'unlimited',
    emailGeneral: true,
    emailSuccess: true,
    emailFailure: true,
    emailStorageLimit: false,
  };

export const BACKUPS_MANAGEMENT_SEGMENTED_TRACK_SX = {
  boxSizing: 'border-box',
  border: '1px solid',
  borderColor: 'grey.300',
  borderRadius: 4,
  bgcolor: 'background.paper',
  p: 0.5,
};

export const BACKUPS_MANAGEMENT_SEGMENTED_TAB_SX = {
  boxSizing: 'border-box',
  minHeight: 40,
  width: 'fit-content',
  py: 1,
  px: 3,
  textTransform: 'none' as const,
  fontWeight: 600,
  fontSize: '0.875rem',
  lineHeight: 1.25,
  color: 'text.primary',
  borderRadius: 3,
  border: '2px solid transparent',
  '&.Mui-selected': {
    color: 'text.primary',
    borderColor: 'primary.main',
    bgcolor: 'background.paper',
  },
};

export const BACKUPS_MANAGEMENT_SEGMENTED_TAB_SX_MOBILE_LAYOUT = {
  boxSizing: 'border-box',
  flex: 1,
  minWidth: 0,
  width: 'auto',
  maxWidth: 'none',
  px: 1.5,
  fontSize: '0.8125rem',
  fontWeight: 600,
  whiteSpace: 'nowrap' as const,
};

export const BACKUPS_MANAGEMENT_SETTINGS_PANEL_SX = {
  border: '1px solid',
  borderColor: 'grey.300',
  borderRadius: 4,
  overflow: 'hidden',
  padding: 0,
};
